import { render } from "./page_control.html?vue&type=template&id=5a43c768&external"
import script from "./page_control.js?vue&type=script&lang=js&external"
export * from "./page_control.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__